import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M7.886 14.722s.198-.847 2-.776c1.8.07 3.764.07 3.764.07M7.976 17.022l7.764.053"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M5.472 15.893c-1.838.423-3.567-2.63-1.604-4.005 1.261-.883 4.035-.688 3.981 2.152l.036 6c0 .282-.18.546-.468.652-.486.177-1.315.353-2.216.053a.72.72 0 0 1-.468-.582l-.45-4.023M18.406 15.893c1.855.423 3.567-2.612 1.603-4.005-1.261-.883-4.035-.688-3.981 2.152l-.036 6.035c0 .264.162.511.414.635.469.212 1.315.406 2.342-.018a.74.74 0 0 0 .432-.582l.126-2.082"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M5.075 11.394s-1.44-7.8 6.251-8.31c5.868-.391 7.43 1.023 7.54 2.748m0 0a4 4 0 0 1-.082 1.049C18.362 9.024 15.455 9.777 15 7.5c-.361-1.806 1.735-2.211 3.867-1.668m0 0C20.034 6.129 21.21 6.71 22 7.5"
    />
  </svg>
);
export const ChairIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
